import { useEffect, useState } from "react";
import { Power, X } from "lucide-react";
import logoWeiss from "@/assets/logo-weiss.webp";

export default function PowerOutageEasterEgg() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Strom aus? Notdienst-Hinweis öffnen"
        title="Strom aus?"
        className="inline-flex items-center gap-2 text-foreground-500 hover:text-[#4CAF50] transition-colors text-[11px] group"
      >
        <span className="relative inline-flex items-center justify-center w-8 h-5 rounded-full border border-foreground-700 group-hover:border-[#4CAF50] transition-colors">
          <span className="absolute left-0.5 top-0.5 w-3.5 h-3.5 rounded-full bg-foreground-600 group-hover:bg-[#4CAF50] transition-all" />
        </span>
        <span>Strom aus?</span>
      </button>

      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Notdienst bei Stromausfall"
          onClick={() => setOpen(false)}
          className="fixed inset-0 z-[9999] bg-[#0A0A0A] flex flex-col items-center justify-center px-6 animate-[poe-fade_0.4s_ease-out_forwards]"
        >
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            aria-label="Licht wieder an"
            className="absolute top-5 right-5 md:top-7 md:right-7 w-11 h-11 rounded-full border border-white/20 text-white/80 hover:text-white hover:border-white flex items-center justify-center transition-colors"
          >
            <X size={20} />
          </button>

          <div
            onClick={(e) => e.stopPropagation()}
            className="flex flex-col items-center text-center max-w-xl"
          >
            <img
              src={logoWeiss}
              alt="Zweering Elektrotechnik"
              className="h-16 md:h-20 w-auto mb-10 poe-pulse"
            />

            <h2
              className="font-heading font-bold text-white mb-4 leading-tight"
              style={{ fontSize: "clamp(1.25rem, 5vw, 3rem)" }}
            >
              Strom weg? Wir bringen ihn zurück.
            </h2>
            <p className="text-foreground-300 text-base md:text-lg mb-9 max-w-md">
              Kein Strom im Haus? Wir rücken aus — Notdienst für Emmerich am Rhein und Umgebung.
            </p>

            <a
              href="tel:+492822791010"
              className="inline-flex items-center gap-3 bg-[#4CAF50] hover:bg-[#43A047] text-white font-heading font-bold px-8 py-4 rounded-full text-lg md:text-xl transition-colors"
            >
              <Power size={22} />
              02822 791010
            </a>

            <button
              type="button"
              onClick={() => setOpen(false)}
              className="mt-8 text-sm text-foreground-400 hover:text-white transition-colors underline-offset-4 hover:underline"
            >
              Licht wieder an
            </button>
          </div>

          <style>{`
            @keyframes poe-fade {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes poe-pulse {
              0%, 100% { opacity: 0.55; transform: scale(1); filter: drop-shadow(0 0 0 rgba(76,175,80,0)); }
              45%      { opacity: 1;    transform: scale(1.04); filter: drop-shadow(0 0 18px rgba(76,175,80,0.55)); }
              60%      { opacity: 0.85; transform: scale(1.01); }
            }
            .poe-pulse { animation: poe-pulse 1.6s ease-in-out infinite; }
            @media (prefers-reduced-motion: reduce) {
              .poe-pulse { animation-duration: 4s; }
            }
          `}</style>
        </div>
      )}
    </>
  );
}
